/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Settings_Plc_Maintenance_LinkInputs */



/**
* | output |
* | --- |
* | "Link :" |
*
* @param {Module_Settings_Plc_Maintenance_LinkInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_settings_plc_maintenance_link = /** @type {((inputs?: Module_Settings_Plc_Maintenance_LinkInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Settings_Plc_Maintenance_LinkInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Link : ")
	return /** @type {LocalizedString} */ ("Lien : ")
});